/**
 * Escapes special regex characters in a string for safe use in RegExp constructor.
 * Prevents regex injection when using user input as a pattern.
 */
export const escapeRegExp = (str: string): string => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

/**
 * Checks if a date string represents a date in the past.
 */
export const isPastDate = (dateString: string): boolean => {
  return new Date(dateString) < new Date()
}
